import axios from 'axios';
import Instance from './interceptor';
import { API } from '../constants/Constants';
import Toast from '../components/pages/utils/Toast';

export const inviteOrganizationRootAdmin = async ({
  invitationEmail,
  expiryTime,
  organization,
  referredBy,
}) => {
  try {
    const response = await Instance.post(`${API.INVITE_ROOT_ADMIN}`, {
      email: invitationEmail,
      expiryTime,
      organization,
      referredBy,
    });

    if (response) {
      Toast({ message: `${response?.data?.message}`, variant: 'success' });
      return response;
    }
  } catch (error) {
    if (error?.response?.data) {
      Toast({
        message: `${error?.response?.data?.errorMessage}`,
        variant: 'error',
      });
    }
  }
};

export const resendInviteOrganizationRootAdmin = async ({ email }) => {
  try {
    return await Instance.post(`${API.INVITE_ROOT_ADMIN}`, {
      email,
    });
  } catch (error) {
    if (error?.response?.data) {
      Toast({
        message: `${error?.response?.data?.errorMessage}`,
        variant: 'error',
      });
    }
  }
};

export const verifyTokenForRootAdmin = async (token) => {
  try {
    return await axios.get(`${API.VERIFY_TOKEN}/${token}`);
  } catch (error) {
    if (error?.response?.data) {
      Toast({
        message: `${error?.response?.data?.errorMessage}`,
        variant: 'error',
      });
    }
  }
};
